import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';
import { Box, useTheme } from '@mui/material';
import { THUMBNAIL_HEIGHT } from '../consts';
import { ThumbnailImageMetadata } from '../types';
import { calculateThumbnailDisplayRatio, calculateThumbnailFrameWidth } from '../utils';
import { ThumbnailFrame } from './ThumbnailFrame';

interface Props {
  metadata: ThumbnailImageMetadata;
  targetHeight?: number;
}

/**
 * Placeholder when no thumbnail exists for the requested timestamp.
 * Background follows the app theme so it matches LoadingThumbnail.
 */
export function MissingThumbnail({ metadata, targetHeight = THUMBNAIL_HEIGHT }: Props) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const displayRatio = calculateThumbnailDisplayRatio(metadata, targetHeight);
  const width = calculateThumbnailFrameWidth(metadata, displayRatio);

  return (
    <ThumbnailFrame>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: `${width}px`,
          height: `${targetHeight}px`,
          bgcolor: isDark ? 'background.default' : 'grey.100',
        }}
      >
        <ImageNotSupportedIcon
          sx={{
            color: 'grey.500',
            fontSize: '1.25rem',
          }}
        />
      </Box>
    </ThumbnailFrame>
  );
}
